/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationSizeResource } from './';
import {
    OrganizationSizeResourceFromJSON,
    OrganizationSizeResourceFromJSONTyped,
    OrganizationSizeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateSizeRequest
 */
export interface UpdateSizeRequest {
    /**
     * 
     * @type {OrganizationSizeResource}
     * @memberof UpdateSizeRequest
     */
    organizationSize: OrganizationSizeResource;
}

/**
 * Check if a given object implements the UpdateSizeRequest interface.
 */
export function instanceOfUpdateSizeRequest(value: object): value is UpdateSizeRequest {
    if (!('organizationSize' in value) || value['organizationSize'] === undefined) return false;
    return true;
}

export function UpdateSizeRequestFromJSON(json: any): UpdateSizeRequest {
    return UpdateSizeRequestFromJSONTyped(json, false);
}

export function UpdateSizeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSizeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationSize': OrganizationSizeResourceFromJSON(json['organizationSize']),
    };
}

export function UpdateSizeRequestToJSON(value?: UpdateSizeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationSize': OrganizationSizeResourceToJSON(value['organizationSize']),
    };
}

